module.exports = __webpack_public_path__ + "media/images/costOfAbuse-graphic-lvl2-d7b1428d974eac7e759aef45b73c5607.svg";